import { useEffect, useState, Fragment } from 'react';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import { Grid } from '@mui/material';
import CustomDatePicker from "../common/DatePicker";
import momentDate from "../../utils/moment-date";
import { useFormContext } from 'react-hook-form';
import {
  ReportTypeChoices,
  DEFAULT_TIME_RANGES_FOR_REPORT_TYPE,
  REPORT_TYPES,
  FREQUENCY_OPTIONS,
  FREQUENCY,
  TIME_RANGES,
} from '../Constants';
import {
  createReportChoicesDynamically,
  createFrequencyChoicesDynamically,
  requiredValidation,
  createTimeRangeChoicesDynamically,
  getChoicesForTimeRange,
} from '../../utils/util';
import {
  validateReportRequestCreation,
  getPastDateFromFrequency,
  showTimeRange,
  getPossibleChoicesAndDefaultValue,
  canFieldBeHidden,
  prepareEndDate,
  prepareStartDate,
  showTimeRangeForBundle,
  getDefaultValueForTimeRangeInBundle,
  areDependentValidationsSatisfied
} from '../../utils/CreateReportUtils';
import moment from "moment-timezone";
import {
  SelectInput,
  RadioButtonGroupInput,
  CheckboxGroupInput,
  SelectArrayInput,
  isEmpty,
  required,
} from "react-admin";
import { isSchedulingSupported, isReportSchedulingEnabled } from "../DataProvider";
import { useWatch } from 'react-hook-form';
import { useLocation } from 'react-router';
import { extractQueryParamsFromURL } from '../../mappers/Report';
import {datePickerError,padding2,textColor,width} from '../Styles'

let reportTypeFilterString = "";
export const ReportTypeAndDynamicTimeRange = (props) => {

  const {
    fromField, 
    toField, 
    isBundleTemplate, 
    multiReportField, 
    reportField, 
    frequencyField, 
    timeRangeField 
  } = props;
  const form = useFormContext();
  const values = useWatch();
  const location = useLocation();

  const timeRangeFromUrl = extractQueryParamsFromURL(location?.search, 'timeRange');
  const resolvedTimeRangeFromUrl = timeRangeFromUrl ? (TIME_RANGES[timeRangeFromUrl] ?? timeRangeFromUrl) : null;
  const startDateFromUrl = extractQueryParamsFromURL(location?.search, 'startDate');
  const endDateFromUrl = extractQueryParamsFromURL(location?.search, 'endDate');

  const [defaultReportType, setDefaultReportType] = useState();
  const [defaultRange, setDefaultRange] = useState();
  const [timeRangePossibleValues, setTimeRangePossibleValues] = useState([]);
  const [reportTypePossibleValues, setReportTypePossibleValues] = useState([]);

  useEffect(() => {//crs-hook
    const allowedReports =
      !isEmpty(reportField?.possibleValues)
        ? createReportChoicesDynamically(reportField.possibleValues)
        : ReportTypeChoices;

    const initialReportType = allowedReports.length === 1 ? allowedReports[0].id : null;
    
    setReportTypePossibleValues(allowedReports);
    
    setDefaultReportType(initialReportType);
    form.setValue("reportType", initialReportType);
    form.setValue("multiReportType", multiReportField?.defaultValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportField, multiReportField?.defaultValue, props.selectedTemplateId]);

  useEffect(() => {//crs-hook
    
    const choicesAndDefaultValue = getPossibleChoicesAndDefaultValue(values.reportType, timeRangeField);
  
    let initialDefaultRange = choicesAndDefaultValue ? TIME_RANGES[choicesAndDefaultValue.defaultValue] : DEFAULT_TIME_RANGES_FOR_REPORT_TYPE[values.reportType]
    initialDefaultRange = isBundleTemplate ? getDefaultValueForTimeRangeInBundle(multiReportField?.defaultValue ?? [], timeRangeField) : initialDefaultRange;

    // creating time range choices
    const timeRangeChoices = choicesAndDefaultValue
      ? createTimeRangeChoicesDynamically(choicesAndDefaultValue.values)
      : isBundleTemplate && !isEmpty(timeRangeField?.possibleValues)
        ? createTimeRangeChoicesDynamically(timeRangeField?.possibleValues)
        : getChoicesForTimeRange();

    setTimeRangePossibleValues(timeRangeChoices);

    const isUrlRangeAllowed = resolvedTimeRangeFromUrl && timeRangeChoices.some(c => c.id === resolvedTimeRangeFromUrl);
    const rangeToSet = startDateFromUrl || endDateFromUrl ? TIME_RANGES.CUSTOM
      : isUrlRangeAllowed ? resolvedTimeRangeFromUrl
      : initialDefaultRange;
    setDefaultRange(rangeToSet);
    form.setValue("timeRange", rangeToSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.reportType, timeRangeField, props.selectedTemplateId, reportField, isBundleTemplate, multiReportField?.defaultValue]);

  useEffect(() => {//crs-hook          
    if(values.timeRange !== "CUSTOM"){                      
      form.setValue("startDate", undefined);
      form.setValue("endDate", undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps          
  },[values.reportType, values.selectedTemplateId, values.timeRange]);
  
  const defaultStartDate = prepareStartDate(fromField, props.startDate, props.isMatterShow, values.reportType, startDateFromUrl);
  const defaultEndDate = prepareEndDate(props.endDate, toField, endDateFromUrl);

  const filterReportType = (e) => {
    const searchTerm = e.key.toLowerCase();
    let newReportType = null;
    if (reportTypeFilterString && searchTerm === reportTypeFilterString[0]) {
      reportTypeFilterString = `${reportTypeFilterString}${searchTerm}`;
      const filteredReportTypes = reportTypePossibleValues.filter((report) => report.name.toLowerCase().startsWith(searchTerm));
      if (filteredReportTypes && filteredReportTypes.length) {
        const index =
          filteredReportTypes.length >= reportTypeFilterString.length
            ? reportTypeFilterString.length
            : filteredReportTypes.length;
        newReportType = filteredReportTypes[index - 1].id;
      }
    } else {
      const filteredReportType = reportTypePossibleValues.find((report) => report.name.toLowerCase().startsWith(searchTerm));
      if (filteredReportType) {
        newReportType = filteredReportType.id;
      }
      reportTypeFilterString = searchTerm;
    }
    if (newReportType) {
      form.setValue('reportType', newReportType);
    }
  };  

  return (
    <Fragment>
    { 
    isBundleTemplate
    ?
      <Grid sx={{
        ...(multiReportField && canFieldBeHidden(
          multiReportField.isHidden,
          multiReportField.required,
          multiReportField.defaultValue          
        ) ?{ display: "none" } : {})
      }}>
        <ListItem sx={padding2.y}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={4} sx={textColor.gray}>
              {multiReportField ? multiReportField.displayName : 'Report Type(s)'}
              {multiReportField && multiReportField.required && <span style={{...textColor.red, marginLeft: '3px'}}>*</span>}
            </Grid>
            <Grid item xs={12} md={props.isMatterShow ? 8 : 6} lg={props.isMatterShow ? 8 : 5}>
              <SelectArrayInput
                id="reports-create-multi-report-type-select"
                source="multiReportType"
                name="multiReportType"
                variant="outlined"
                size="small"
                label={multiReportField ? multiReportField.placeholder : 'Choose an option'}
                choices={ReportTypeChoices}
                defaultValue={multiReportField?.defaultValue}
                validate={requiredValidation}
                //onKeyPress={filterReportType}
                sx={{ ...width.fluid.w100, marginBottom: "-15px" }}
              />
            </Grid>
          </Grid>
        </ListItem>
        <Divider light />
      </Grid>
      : <Grid sx={{
        ...(reportField && canFieldBeHidden(
          reportField.isHidden,
          true,
          defaultReportType
        ) ?{ display: "none" } : {})
      }}>
        <ListItem sx={padding2.y}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={4} sx={textColor.gray}>
              {reportField ? reportField.displayName : 'Report Type'}
              <span style={{...textColor.red, marginLeft: '3px'}}>*</span>
            </Grid>
            <Grid item xs={12} md={props.isMatterShow ? 8 : 6} lg={props.isMatterShow ? 8 : 5}>
              <SelectInput
                id="reports-create-report-type-select"
                source="reportType"
                name="reportType"
                variant="outlined"
                size="small"
                label={reportField ? reportField.placeholder : 'Choose an option'}
                choices={reportTypePossibleValues}                
                defaultValue={defaultReportType}
                validate={requiredValidation}
                onKeyPress={filterReportType}
                sx={{ ...width.fluid.w100, marginBottom: "-15px" }}
                isRequired
              />
            </Grid>
          </Grid>
        </ListItem>
        <Divider light />
      </Grid> }
      {!props.isMatterShow && <FrequencyOptions frequencyField={frequencyField} />}
      {(showTimeRange(values.reportType) || showTimeRangeForBundle(values.multiReportType)) && (props.isMatterShow || !isSchedulingSupported(values.reportType, values.frequency)) && (
        <Fragment>
          <Grid sx={{
            ...(timeRangeField && canFieldBeHidden(
              timeRangeField.isHidden,
              timeRangeField.required,
              defaultRange
            ) ? { display: "none" } : {})
          }}>
            <ListItem sx={padding2.y}>
              <Grid container alignItems="center">
                <Grid item xs={12} md={4} sx={textColor.gray}>
                  {timeRangeField ? timeRangeField.displayName : 'Time Range'}
                  <span style={{...textColor.red, marginLeft: '3px'}}>*</span>
                </Grid>
                <Grid item xs={12} md={props.isMatterShow ? 8 : 6} lg={props.isMatterShow ? 8 : 5}>
                  <SelectInput
                    id="reports-create-time-range-select"
                    source="timeRange"
                    name="timeRange"
                    variant="outlined"
                    size="small"
                    label={timeRangeField ? timeRangeField.placeholder : 'Choose an option'}
                    choices={timeRangePossibleValues}
                    defaultValue={defaultRange}
                    validate={requiredValidation}
                    isRequired
                    sx={{ ...width.fluid.w100, marginBottom: "-15px" }}
                    />
                </Grid>
              </Grid>
            </ListItem>
            <Divider light />
          </Grid>
          <DynamicDateRange isMatterShow={props.isMatterShow} startDate={defaultStartDate} endDate={defaultEndDate} toField={toField} isBundleTemplate={isBundleTemplate} />
        </Fragment>
      )}
    </Fragment>
  );
};

const FrequencyOptions = (props) => {
  const frequencyField = props.frequencyField;
  const values = useWatch();
  const form = useFormContext();
  const location = useLocation();

  const frequencyFromUrl = extractQueryParamsFromURL(location?.search, 'frequency');
  const resolvedFrequencyDefault = frequencyFromUrl ?? frequencyField?.defaultValue ?? 'ONCE';

  useEffect(() => {
    if(values.reportType === REPORT_TYPES.TRANSACTION_DOWNLOAD){
      form.setValue("frequency", resolvedFrequencyDefault);
      form.setValue("scheduleReminders", ['scheduleReminders']);

    }else{
      form.resetField("frequency");
      form.resetField("scheduleReminders");      
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps    
  },[values.reportType, values.selectedTemplateId, frequencyField?.defaultValue])
  
  if (
    !values.reportType ||
    isReportSchedulingEnabled() === false ||
    ((!frequencyField || !frequencyField.dependentOn) && values.reportType !== REPORT_TYPES.TRANSACTION_DOWNLOAD) ||
    (frequencyField && frequencyField.dependentOn && !areDependentValidationsSatisfied(frequencyField.dependentOn, values))
  )
    return null;

  return (
    (values.reportType === REPORT_TYPES.TRANSACTION_DOWNLOAD
    && isReportSchedulingEnabled() &&
    <Fragment>
      <Grid sx={{
        ...(frequencyField && canFieldBeHidden(
          frequencyField.isHidden,
          true,
          frequencyField.defaultValue)
          ? { display: "none" } : {})
      }}>
        <ListItem sx={padding2.y}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={4} sx={textColor.gray}>
              {frequencyField ? frequencyField.displayName : 'Frequency'}              
              <span style={{...textColor.red, marginLeft: '3px'}}>*</span>
            </Grid>
            <Grid item xs={12} md={6} lg={5}>
              <RadioButtonGroupInput
                id="reports-create-frequency-radio-group"
                label={false}
                name="frequency"
                source="frequency"
                validate={required("The frequency is required")}
                row={true}
                defaultValue={resolvedFrequencyDefault}
                choices={
                  frequencyField && frequencyField?.possibleValues ? createFrequencyChoicesDynamically(frequencyField.possibleValues) : FREQUENCY_OPTIONS
                }
                sx={{marginBottom: "-8px" }}
              />
            </Grid>
          </Grid>
        </ListItem>
        <Divider light />
      </Grid>
      <ScheduleEndDateComponent />
    </Fragment>)
  );
};

const ScheduleEndDateComponent = () => {
  const values = useWatch();
  const reportScheduleMinDate = getPastDateFromFrequency(
    new Date(),
    values.frequency
  );

  if (values.frequency && values.frequency !== FREQUENCY.ONCE) {    
    return (
      <Fragment>
        <ListItem sx={padding2.y}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={4} sx={textColor.gray}>
              End Date Of First Report
              <span style={{...textColor.red, marginLeft: '3px'}}>*</span>
            </Grid>
            <Grid item xs={12} md={5} lg={4}>
              <CustomDatePicker
                isStartDate={false}
                isEndDateOfFirstReport={true}
                reportScheduleMinDate={reportScheduleMinDate}
                sx={{ ...width.fluid.w100, marginBottom: "-15px" }}
              />
              <CheckboxGroupInput
                id="reports-create-schedule-reminders-checkbox"
                source='scheduleReminders'
                choices={[
                  { id: 'scheduleReminders', name: 'Send Reminder Emails'},
                ]}
                defaultValue={['scheduleReminders']}
                label={false}
                helperText={false}
                sx={{ marginBottom: "0" }}
              />
            </Grid>
          </Grid>
        </ListItem>
        <Divider light />
        <ListItem sx={padding2.y}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={4} sx={textColor.gray}>Dates Of First Report</Grid>
            <Grid item xs={12} md={6} lg={5} id="dates-of-first-report">
              <strong>
                {values.firstPeriodEndDate
                  ? momentDate(
                      getPastDateFromFrequency(
                        values.firstPeriodEndDate,
                        values.frequency
                      )
                    ).format("YYYY-MM-DD")
                  : momentDate(
                      getPastDateFromFrequency(new Date(), values.frequency)
                    ).format("YYYY-MM-DD")}
                {" to "}
                {values.firstPeriodEndDate
                  ? momentDate(values.firstPeriodEndDate).format("YYYY-MM-DD")
                  : moment().format("YYYY-MM-DD")}
              </strong>
            </Grid>
          </Grid>
        </ListItem>
        <Divider light />
      </Fragment>
    );
  }

  return null;
};

const DynamicDateRange = (props) => {
  const values = useWatch();
  const { toField, isBundleTemplate } = props;

  return (
    (showTimeRange(values.reportType) || showTimeRangeForBundle(values?.multiReportType)) &&
    (props.isMatterShow || !isSchedulingSupported(values.reportType, values.frequency)) &&
    values.timeRange !== undefined &&
    values.timeRange === "CUSTOM" && (
      <Fragment>
        <ListItem sx={padding2.y}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={4} sx={textColor.gray}>
              From
              <span style={{...textColor.red, marginLeft: '3px'}}>*</span>
            </Grid>
            <Grid item xs={12} md={5} lg={4} sx={{marginBottom: "-15px"}} className={{'invalid-date-range': validateReportRequestCreation(values).startDate != null}}>
              <CustomDatePicker isStartDate={true} startDate={props.startDate} endDate={props.endDate} isBundleTemplate={isBundleTemplate} />
              <p style={datePickerError} id="start-date-error">
                {validateReportRequestCreation(values).startDate != null ? validateReportRequestCreation(values).startDate : (<div>&nbsp;</div>) }
              </p>
            </Grid>
          </Grid>
        </ListItem>
        <Divider light />
        <Grid 
          sx={{
          ...(toField && canFieldBeHidden(
            toField.isHidden,
            false, // toField is not required`
            toField.defaultValue)
            ? { display: "none" } : {})
          }}>
          <ListItem sx={padding2.y}>
            <Grid container alignItems="center">
              <Grid item xs={12} md={4} sx={textColor.gray}>
                To
              </Grid>
              <Grid item xs={12} md={5} lg={4} sx={{marginBottom: "-15px"}} className={{'invalid-date-range': validateReportRequestCreation(values).endDate != null}}>
                <CustomDatePicker isStartDate={false} isEndDate={true} startDate={props.startDate} endDate={props.endDate} isBundleTemplate={isBundleTemplate} />
                <p style={datePickerError} id='end-date-error'>
                  {validateReportRequestCreation(values).endDate != null ? validateReportRequestCreation(values).endDate : (<div>&nbsp;</div>) }
                </p>
              </Grid>
            </Grid>
          </ListItem>
        <Divider light />
        </Grid>
      </Fragment>
    )
  );
};

export default ReportTypeAndDynamicTimeRange;